import React from "react";
import { SelectBox, Validator } from "devextreme-react";

class SelectField extends React.PureComponent {
  render() {
    const {
      acceptCustomValue,
      label,
      displayExpr,
      valueExpr,
      searchEnabled,
      dataSource,
      items,
      disabled,
      onChange,
      id,
      optional,
      validation,
      required,
      dropdownMaxHeight,
      styleRoot,
      // value,
      // placeholder,
      selected,
      text,
      defaultValue,
      ...rest
    } = this.props;
    return (
      <div className="field-newDenuncia" style={{ marginLeft: optional ? 20 : 0, ...styleRoot }}>
        {label && <h3><p>{label}{required ? <span className="label-red-requerido"> *</span> : ""}</p></h3>}
        <SelectBox
          searchEnabled={searchEnabled}
          acceptCustomValue={acceptCustomValue}
          // placeholder= {placeholder || ""}
          items={items}
          dataSource={dataSource}
          disabled={disabled}
          onValueChanged={onChange}
          displayExpr={displayExpr}
          valueExpr={valueExpr}
          // value={value}
          defaultValue={defaultValue}
          onOpened={(e) => {
            e.component._popup.option("maxHeight", dropdownMaxHeight);
          }}
          id={id}
          {...rest}
        >
          <Validator
            validationRules={validation !== false ? [{
              type: "required",
              message: "Este campo es requerido",
            }] : []}
          />

        </SelectBox>
      </div>
    );
  }
}

export default SelectField;
